import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FieldErrorCodes = {
  FieldAnswerForbidden: {
    code: 'field/answer-forbidden',
    message: 'Você não tem permissão para responder este campo.',
    explanation: 'Você não tem permissão para responder a este campo. Isso pode ser devido a restrições na configuração do fluxo.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldAnswerForbiddenAfterFirstMove: {
    code: 'field/answer-forbidden-after-first-move',
    message: 'O formulário inicial não pode mais ser respondido, pois o card já foi movido de etapa.',
    explanation: 'Você não pode responder ao formulário inicial porque o card já foi movido para outra etapa. Isso é devido às configurações do fluxo.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldAnswerForbiddenCurrentStageMismatch: {
    code: 'field/answer-forbidden-current-stage-mismatch',
    message: 'O formulário da etapa não pode ser respondido, pois o card não está na etapa correspondente.',
    explanation: 'Você não pode responder ao formulário da etapa porque o card não está na etapa correspondente. O formulário dessa etapa só pode ser respondido quando o card estiver na etapa na qual ele pertence.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration#formulário-da-etapa',
      },
    ],
  },
  FieldAnswerForbiddenInStage: {
    code: 'field/answer-forbidden-in-stage',
    message: 'O formulário inicial não pode ser respondido nesta etapa.',
    explanation: 'Você não pode responder ao formulário inicial nesta etapa. Isso é devido às configurações do fluxo.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldForbiddenOperationForType: {
    code: 'field/forbidden-operation-for-type',
    message: 'A operação não é permitida para o tipo deste campo.',
    explanation: 'A operação que você está tentando realizar não é permitida para o tipo deste campo. Por exemplo, tentar pesquisar por registros em um campo que não seja de banco de dados.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Tipos de Perguntas',
        path: '/wiki/docs/pipe/forms#tipos-de-perguntas',
      },
    ],
  },
  FieldInvalidValue: {
    code: 'field/invalid-value',
    message: 'O valor informado em um dos campos não atende aos requisitos de formato. Verifique se datas, números e textos estão no formato correto e tente novamente.',
    explanation:
      'O valor fornecido para um campo no formulário é inválido. Cada tipo de campo tem seus próprios requisitos de formato e validação. Alguns exemplos incluem datas em formato incorreto, números fora do intervalo permitido ou texto que excede o comprimento máximo.',
    localizations: {},
  },
  FieldMissingConfiguration: {
    code: 'field/missing-configuration',
    message: 'A configuração necessária para este campo está incompleta ou ausente.',
    explanation: 'A configuração necessária para este campo está faltando. Verifique a configuração do campo no esquema do formulário.',
    localizations: {},
  },
  FieldNotFound: {
    code: 'field/not-found',
    message: 'Campo não encontrado.',
    explanation: 'O campo que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  FieldRequired: {
    code: 'field/required',
    message: 'Um ou mais campos obrigatórios não foram preenchidos. Procure pelos campos marcados com asterisco (*) e complete as informações necessárias.',
    explanation: 'Um campo obrigatório no formulário não foi preenchido. O formulário não pode ser enviado até que todos os campos obrigatórios sejam preenchidos.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Formulários',
        path: '/wiki/docs/pipe/forms',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'field'>;
